import { FRONT_URL } from "@/shared/config/front-url";

export type LegalDocumentSlug = "offer" | "terms" | "privacy" | "consent";

export type LegalDocumentMeta = {
  slug: LegalDocumentSlug;
  title: string;
  navLabel: string;
  url: string;
};

export const LEGAL_DOCUMENTS: Record<LegalDocumentSlug, LegalDocumentMeta> = {
  offer: {
    slug: "offer",
    title:
      "Публичная оферта на заключение договора об использовании сервиса SellerAlert",
    navLabel: "Публичная оферта",
    url: `${FRONT_URL}/legal/offer`,
  },
  terms: {
    slug: "terms",
    title: "Пользовательское соглашение сервиса SellerAlert",
    navLabel: "Условия пользования",
    url: `${FRONT_URL}/legal/terms`,
  },
  privacy: {
    slug: "privacy",
    title: "Политика обработки персональных данных сервиса SellerAlert",
    navLabel: "Политика конфиденциальности",
    url: `${FRONT_URL}/legal/privacy`,
  },
  consent: {
    slug: "consent",
    title: "Согласия на обработку персональных данных",
    navLabel: "Согласие на обработку данных",
    url: `${FRONT_URL}/legal/consent`,
  },
};
